import { type ReactNode } from "react";
import { Navigate } from "react-router-dom";
import { useAuthStore } from "../store";

export function RequirePermissionRoute({
  permission,
  children,
  fallback = "/dashboard",
}: {
  permission: string | string[];
  children: ReactNode;
  fallback?: string;
}) {
  // `permission` may be a single key or a list. List = "any of" semantics so
  // a route can be opened by any role bundle that grants at least one match.
  const perms = useAuthStore((s) => s.permissions);
  const required = Array.isArray(permission) ? permission : [permission];
  const ok = required.some((p) => perms.has(p));
  if (!ok) return <Navigate to={fallback} replace />;
  return <>{children}</>;
}
